module.exports = __webpack_public_path__ + "img/redux.f18023dc.png";